export default "__VITE_ASSET__CGOvzjb___"